// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"TextA_thecomp__bUuIF"};